<app-browser-header>
  <div *ngIf="serviceTypeOptions?.length" class="filters-bar">
    <div class="service-types-section">
      <div id="prev" class="service-type-filters-button prev">
        <ion-icon class="service-type-filters-button-icon" src="/assets/custom-icons/vendors-page/chevron.svg"></ion-icon>
      </div>
      <swiper
        tappable
        class="service-types"
        [dir]="globalHeaderServiceTypesSliderDirection"
        [config]="globalHeaderServiceTypesSliderConfig"
      >
        <ng-template swiperSlide *ngFor="let option of serviceTypeOptions">
          <div
            class="service-type-filter"
            [class.active]="option.serviceTypes === selectedServiceType"
            (click)="onServiceTypeChange(option.serviceTypes)"
          >
            {{ option.text }}
            <span
              *ngIf="option.badge"
              class="service-type-filter-badge"
              [style.backgroundColor]="option.badge.backColor"
              [style.color]="option.badge.foreColor"
            >
              {{ option.badge.text }}
            </span>
          </div>
        </ng-template>
      </swiper>
      <div id="next" class="service-type-filters-button next">
        <ion-icon class="service-type-filters-button-icon" src="/assets/custom-icons/vendors-page/chevron.svg"></ion-icon>
      </div>
    </div>

    <div class="area-date-time-section">
      <div tappable class="area" (click)="onOpenAreaModal()">
        <span *ngIf="selectedAddress">{{ selectedAddress.area.name }}</span>
        <span *ngIf="!selectedAddress">{{ "WHERE" | translate }}</span>
        <ion-icon src="/assets/custom-icons/b-angle-down.svg"></ion-icon>
      </div>
      <div tappable class="time" (click)="onOpenDateTimePicker()" *ngIf="showHeaderDateTimeButton">
        <span *ngIf="isOrderForNowSelected">{{ "NOW" | translate }}</span>
        <span *ngIf="!isOrderForNowSelected && selectedDateTime">{{ selectedDateTime | formatDateTime : { format: "MMM DD HH:mm" } }}</span>
        <span *ngIf="!isOrderForNowSelected && !selectedDateTime">{{ "WHEN" | translate }}</span>
        <ion-icon src="/assets/custom-icons/b-angle-down.svg"></ion-icon>
      </div>
    </div>
  </div>

  <ion-icon
    searchBarIcon
    *ngIf="showHeaderFiltersButton"
    class="search-bar-filters-icon"
    [class.active]="hasSelectedTags"
    (click)="onShowTagsModalPage()"
    src="/assets/custom-icons/vendors-page/filters.svg"
  ></ion-icon>
</app-browser-header>

<div class="main-header" data-cy="main-header">
  <div class="header-item header-item-one">
    <div tappable (click)="onRedirectToHomePage()" class="back-to-home-button">
      <div class="back-to-home-icon-container">
        <ion-icon class="back-to-home-icon" src="/assets/custom-icons/shared/back-icon.svg"></ion-icon>
      </div>
      <div class="back-to-home-text">
        <div class="back-to-home-text-secondary">{{ "BROWSING" | translate }}</div>
        <div class="back-to-home-text-primary">{{ selectedServiceTypeName }}</div>
      </div>
    </div>

    <div class="area-date-time-pickers">
      <div
        tappable
        class="time"
        @animatedIcon
        data-cy="header-date-time-text"
        (click)="onOpenDateTimePicker()"
        *ngIf="showHeaderDateTimeButton"
      >
        <span *ngIf="isOrderForNowSelected">{{ "NOW" | translate }}</span>
        <span *ngIf="!isOrderForNowSelected && selectedDateTime">{{ selectedDateTime | formatDateTime : { format: "MMM DD HH:mm" } }}</span>
        <span *ngIf="!isOrderForNowSelected && !selectedDateTime">{{ "WHEN" | translate }}</span>
        <ion-icon src="/assets/custom-icons/b-angle-down.svg"></ion-icon>
      </div>
    </div>
  </div>

  <div class="header-item header-item-two">
    <div
      class="search-bar"
      [class.no-popular-tags]="(!popularTags?.firstRow.length && !popularTags?.secondRow.length) || isLoading || isBrowser"
    >
      <div class="search-bar-target" tappable (click)="onOpenSearchPage()">
        <ion-icon class="search-bar-search-icon" src="/assets/custom-icons/vendors-page/search.svg"></ion-icon>
        <span class="search-bar-text">{{ "SERVICE_TYPE_OPTIONS_PAGE.UNIVERSAL_SEARCH_PLACEHOLDER" | translate }}</span>
      </div>

      <ion-icon
        tappable
        @animatedIcon
        *ngIf="showHeaderFiltersButton"
        class="search-bar-filters-icon"
        [class.active]="hasSelectedTags"
        (click)="onShowTagsModalPage()"
        src="/assets/custom-icons/vendors-page/filters.svg"
      ></ion-icon>
    </div>
  </div>

  <div class="header-item header-item-three">
    <div
      class="popular-tags-wrapper"
      [class.one-row]="popularTags?.firstRow?.length && !popularTags?.secondRow?.length"
      [class.two-rows]="popularTags?.firstRow?.length && popularTags?.secondRow?.length"
      *ngIf="(popularTags?.firstRow?.length || popularTags?.secondRow?.length) && !isLoading && !isBrowser"
    >
      <div class="popular-tags">
        <div class="popular-tags-first-row">
          <div tappable class="popular-tag-wrapper" (click)="onTogglePopularTag(tag)" *ngFor="let tag of popularTags.firstRow">
            <div
              class="popular-tag"
              [class.active]="tag.selected"
              [class.with-dot]="tag.tagId === MORE_FILTERS_POPULAR_TAG_ID && hasSelectedTags"
            >
              <ion-icon
                class="popular-tag-more-filters-button"
                *ngIf="tag.tagId === MORE_FILTERS_POPULAR_TAG_ID"
                src="/assets/custom-icons/vendors-page/filters.svg"
              ></ion-icon>
              <div *ngIf="tag.tagId !== MORE_FILTERS_POPULAR_TAG_ID" class="popular-tag-name">{{ tag.name }}</div>
            </div>
          </div>
        </div>
        <div class="popular-tags-second-row">
          <div tappable class="popular-tag-wrapper" (click)="onTogglePopularTag(tag)" *ngFor="let tag of popularTags.secondRow">
            <div
              class="popular-tag"
              [class.active]="tag.selected"
              [class.with-dot]="tag.tagId === MORE_FILTERS_POPULAR_TAG_ID && hasSelectedTags"
            >
              <ion-icon
                class="popular-tag-more-filters-button"
                *ngIf="tag.tagId === MORE_FILTERS_POPULAR_TAG_ID"
                src="/assets/custom-icons/vendors-page/filters.svg"
              ></ion-icon>
              <div *ngIf="tag.tagId !== MORE_FILTERS_POPULAR_TAG_ID" class="popular-tag-name">{{ tag.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div tappable @animatedViewModeButton *ngIf="showViewModeButton" (click)="onToggleCompactView()" class="view-mode-button">
  <ion-icon *ngIf="!enableCompactView" src="/assets/custom-icons/vendors-page/grid-compact.svg"></ion-icon>
  <ion-icon *ngIf="enableCompactView" src="/assets/custom-icons/vendors-page/grid-default.svg"></ion-icon>
</div>

<ion-content [scrollEvents]="true" (ionScroll)="onScroll($event)">
  <ion-grid class="page-container" fixed>
    <div
      class="home-container"
      [class.popular-tags-one-row]="popularTags?.firstRow?.length && !popularTags?.secondRow?.length"
      [class.popular-tags-two-rows]="popularTags?.firstRow?.length && popularTags?.secondRow?.length"
    >
      <div class="feed">
        <div class="browser-mobile-area-date-time-filters">
          <div tappable class="area" (click)="onOpenAreaModal()">
            <span *ngIf="selectedAddress">{{ selectedAddress.area.name }}</span>
            <span *ngIf="!selectedAddress">{{ "WHERE" | translate }}</span>
            <ion-icon src="/assets/custom-icons/b-angle-down.svg"></ion-icon>
          </div>

          <div tappable class="time" (click)="onOpenDateTimePicker()" *ngIf="showHeaderDateTimeButton">
            <span *ngIf="isOrderForNowSelected">{{ "NOW" | translate }}</span>
            <span *ngIf="!isOrderForNowSelected && selectedDateTime">{{
              selectedDateTime | formatDateTime : { format: "MMM DD HH:mm" }
            }}</span>
            <span *ngIf="!isOrderForNowSelected && !selectedDateTime">{{ "WHEN" | translate }}</span>
            <ion-icon src="/assets/custom-icons/b-angle-down.svg"></ion-icon>
          </div>
        </div>

        <div @animatedContent class="service-type-results" *ngIf="!isLoading">
          <div
            class="app-info-messages-container"
            *ngIf="infoMessages?.length && !isLoading && !this.hasSelectedTags && this.isRecommendedSorterSelected"
          >
            <app-info-messages [messages]="infoMessages"></app-info-messages>
          </div>

          <div
            class="app-banner-ads-container"
            *ngIf="banners?.length && !isLoading && !this.hasSelectedTags && this.isRecommendedSorterSelected"
          >
            <app-banner-ads [banners]="banners" (selectBanner)="onSelectBanner($event)"></app-banner-ads>
          </div>

          <div class="loyalty-program-section" *ngIf="!!loyaltyProgramDetails && !this.hasSelectedTags && this.isRecommendedSorterSelected">
            <app-loyalty-program-status
              class="loyalty-program-widget"
              [class.enabled]="loyaltyProgramDetails.enabled"
              [details]="loyaltyProgramDetails"
              [isReloadingDetails]="isReloadingLoyaltyProgramDetails"
              (reloadRequested)="onReloadLoyaltyProgramDetails()"
            ></app-loyalty-program-status>
          </div>

          <div class="highlighted-collections" *ngIf="collections?.length && !this.hasSelectedTags && this.isRecommendedSorterSelected">
            <ng-container *ngFor="let collection of collections; let index = index">
              <app-featured-collection-horizontal-list
                *ngIf="
                  (collection.type === HighlightedCollectionType.Vendors ||
                    collection.type === HighlightedCollectionType.NewVendors ||
                    collection.type === HighlightedCollectionType.MenuItems ||
                    collection.type === HighlightedCollectionType.ReOrder) &&
                  collection.items?.length
                "
                class="highlighted-collection"
                [collection]="collection"
                [collectionIndex]="index"
              ></app-featured-collection-horizontal-list>
            </ng-container>
          </div>

          <div class="vendors-container">
            <div class="vendors-title" *ngIf="visibleResults?.vendors?.length">
              {{ "SERVICE_TYPE_VENDORS" | translate : { serviceTypeName: selectedServiceTypeName } }}
            </div>

            <div class="vendors-title" *ngIf="visibleResults?.vendorsItems?.length">
              {{ "SERVICE_TYPE_ITEMS" | translate : { serviceTypeName: selectedServiceTypeName } }}
            </div>

            <div
              class="filters-empty-results"
              *ngIf="hasSelectedTags && !visibleResults?.vendors?.length && !visibleResults?.vendorsItems?.length"
            >
              <p
                tappable
                (click)="onShowTagsModalPage()"
                class="filters-empty-results-message"
                [innerHTML]="'NO_VENDORS_WITH_SELECTED_TAGS' | translate"
              ></p>
            </div>

            <div #results class="vendors" *ngIf="!!visibleResults?.vendors?.length">
              <app-router-link
                *ngFor="let vendor of visibleResults.vendors"
                [path]="isBrowser && vendor.slug ? ['vendors', vendor.slug] : ['vendors', 'id', vendor.vendorId]"
                [queryParams]="{ tagsIds: selectedTagsIds }"
                [preserveFragmentAndQueryParams]="true"
              >
                <app-vendor
                  [vendor]="vendor"
                  [useCompactView]="!!enableCompactView"
                  [isOrderForNowSelected]="isOrderForNowSelected"
                  [isSelectedServiceTypeDeliveredByBilbayt]="isSelectedServiceTypeDeliveredByBilbayt"
                  (openVendorReviews)="onOpenVendorReviews(vendor.vendorId, vendor.rating)"
                ></app-vendor>
              </app-router-link>
            </div>

            <div #results class="vendors-items" *ngIf="!!visibleResults?.vendorsItems?.length">
              <app-vendor-item
                class="vendor-item"
                *ngFor="let vendorItem of visibleResults.vendorsItems"
                [vendorItem]="vendorItem"
                [selectedTagsIds]="selectedTagsIds"
                (itemSelected)="
                  onOpenItemDetailsModal({
                    vendorId: vendorItem.vendorId,
                    itemId: vendorItem.menuItemId,
                    itemServiceType: vendorItem.serviceType
                  })
                "
              ></app-vendor-item>
            </div>
          </div>

          <ion-infinite-scroll
            [threshold]="'100%'"
            *ngIf="
              !isBrowser &&
              !isLoading &&
              ((visibleResults?.vendors?.length && visibleResults.vendors.length !== filteredResults.vendors.length) ||
                (visibleResults?.vendorsItems?.length && visibleResults.vendorsItems.length !== filteredResults.vendorsItems.length))
            "
            (ionInfinite)="onLoadMoreVendors($event)"
          >
            <ion-infinite-scroll-content></ion-infinite-scroll-content>
          </ion-infinite-scroll>

          <div
            tappable
            *ngIf="
              isBrowser &&
              !isLoading &&
              ((visibleResults?.vendors?.length && visibleResults.vendors.length !== filteredResults.vendors.length) ||
                (visibleResults?.vendorsItems?.length && visibleResults.vendorsItems.length !== filteredResults.vendorsItems.length))
            "
            class="show-more-button"
            (click)="onLoadMoreVendors()"
          >
            <ion-icon class="show-more-button-icon" src="/assets/custom-icons/vendors-page/show-more-arrow.svg"></ion-icon>
            <p class="show-more-button-text">{{ "SHOW_MORE" | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </ion-grid>

  <app-browser-footer></app-browser-footer>
</ion-content>
